import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import Nav from '../components/Nav';
import BottomNav from '../components/BottomNav';

function Families() {
	return (
		<div className='flex flex-col'>
			<Nav />
			<div className='bg-info text-base-100'>
				<h1 className='p-10 text-center font-heading text-2xl'>Families</h1>
			</div>
			<div className='bg-secondary p-10 text-center'>
				<p>
					Use these links to stay connected with our performances and events for
					the school year.
				</p>
			</div>
			<div className='flex max-w-5xl flex-wrap justify-center gap-10 self-center p-10'>
				<Link
					to='https://docs.google.com/document/d/10Jpe7RBgf1H16ctFkL4V0YTtKCCMdSKFwIZQ_fsdlyw/edit?usp=sharing'
					className='btn btn-accent btn-lg w-80 rounded-sm font-lora normal-case lg:h-64 lg:w-64'
				>
					Parent Info
				</Link>
				<Link
					to='https://lbschools.instructure.com/login/canvas'
					className='btn btn-success btn-lg w-80 rounded-sm border border-base-300 font-lora normal-case lg:h-64 lg:w-64'
				>
					Canvas
				</Link>
				<Link
					to='/calendar'
					className='btn btn-primary btn-lg w-80 rounded-sm font-lora normal-case text-base-100 lg:h-64 lg:w-64'
				>
					Calendar
				</Link>
				<a
					href='https://www.facebook.com/groups/213383565765758/'
					className='btn btn-primary btn-lg w-80 rounded-sm font-lora normal-case text-base-100 lg:h-64 lg:w-64'
				>
					Facebook
				</a>
				<a
					href='https://www.instagram.com/mavocalmusic/'
					className='btn btn-success btn-lg w-80 rounded-sm border border-base-300 font-lora normal-case lg:h-64 lg:w-64'
				>
					Instagram
				</a>
				<a
					href='https://twitter.com/lbmamb?s=20&t=D_LKbpETEtZQqtQhnrPqIw'
					className='btn btn-accent btn-lg w-80 rounded-sm font-lora normal-case lg:h-64 lg:w-64'
				>
					Twitter
				</a>
			</div>
			<BottomNav />
			<Footer />
		</div>
	);
}
export default Families;
